import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { SeasonStatus } from '@gbr-monorepo/interfaces';
import { map, Observable, of } from 'rxjs';
import { SeasonService } from '../../../services/season.service';

export class TimeFrameValidators {
    static dateRangeConflict(seasonService: SeasonService): AsyncValidatorFn {
        let lastRangeKey: string | null = null;
        let lastRangeValidationResult: ValidationErrors | null = null;

        return (formGroup: AbstractControl): Observable<ValidationErrors | null> => {
            const _startDate = formGroup.get('startDate')?.value;
            const _endDate = formGroup.get('endDate')?.value;
            const _applicationDeadlineDate = formGroup.get('applicationDeadlineDate')?.value;

            if (!(_startDate && _endDate) || !(_endDate && _applicationDeadlineDate)) {
                return of(null);
            }

            const startDate = new Date(_startDate);
            const endDate = new Date(_endDate);
            const applicationDeadlineDate = new Date(_applicationDeadlineDate);

            if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
                return of(null);
            }

            if (_endDate && _applicationDeadlineDate && endDate > applicationDeadlineDate) {
                return of({ endDateAfterApplicationDeadline: true });
            }

            const rangeKey = `${startDate.toISOString()}|${endDate.toISOString()}`;
            if (lastRangeKey === rangeKey) {
                return of(lastRangeValidationResult);
            }

            return seasonService
                .getSeasons(0, 1, undefined, startDate, endDate, [SeasonStatus.ACTIVE, SeasonStatus.CLOSED])
                .pipe(
                    map(intersectingSeasons => {
                        lastRangeKey = rangeKey;
                        lastRangeValidationResult =
                            intersectingSeasons.metadata.itemCount > 0 ? { dateRangeConflict: true } : null;
                        return lastRangeValidationResult;
                    })
                );
        };
    }
}
